export const ArrowDown = () => (
	<svg className="arrowDown" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="arrowDown">
		<path d="M16 5V27" stroke="#F2F7FC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M7 18L16 27L25 18" stroke="#F2F7FC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
)
